import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useMedicationsSearch = (search = "", isManual = false) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["medications", search, tenantVal],
    queryFn: async () => {
      if (!search) return [];
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/drugsfile/search/${search.replace(/\//g, "-")}`
      );
      return response.data;
    },
    enabled: !isManual && search.length > 2,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
